export const routes = [
    {
        name: 'home_costena',
        path: ['/', '/'],
        page: 'home_costena'
    },
    {
        name: 'terminos',
        path: ['/', '/terminos-condiciones'],
        page: 'terminos'
    },
    {
        name: 'game',
        path: ['/', '/juego/vuela'],
        page: 'game'
    }
]